import * as Types from '../../../graphql-types'

import { gql } from '@apollo/client'
import { Common_ContentFragmentFragmentDoc } from './CommonContentFragment.generated'
import { YiClass_ContentFragmentFragmentDoc } from '../../../gui/components/yi-content-page-details/YIClassContentForm/YIClassContentFragment.generated'
import { YiCourse_ContentFragmentFragmentDoc } from '../../../gui/components/yi-content-page-details/YICourseContentForm/YICourseContentFragment.generated'
import { YiMeditation_ContentFragmentFragmentDoc } from '../../../gui/components/yi-content-page-details/YIMeditationContentForm/YIMeditationContentFragment.generated'
import { GaiaVideo_ContentFragmentFragmentDoc } from '../../../gui/components/yi-content-page-details/GaiaVideoContentForm/GaiaVideoContentFragment.generated'
import { YiPose_ContentFragmentFragmentDoc } from '../../../gui/components/yi-content-page-details/YIPoseContentForm/YIPoseContentFragment.generated'
import { YiArticle_ContentFragmentFragmentDoc } from '../../../gui/components/yi-content-page-details/YIArticleContentForm/YIArticleContentFragment.generated'
import { YiCourseSales_ContentFragmentFragmentDoc } from '../../../gui/components/yi-content-page-details/YICourseSalesContentForm/YICourseSalesContentFragment.generated'
import { YiMemberPromo_ContentFragmentFragmentDoc } from '../../../gui/components/yi-content-page-details/YIMemberPromoContentForm/YIMemberPromoContentFragment.generated'
import { YiHomepageHero_ContentFragmentFragmentDoc } from '../../../gui/components/yi-content-page-details/YIHomepageHeroContentForm/YIHomepageHeroContentFragment.generated'
import { YiSeries_ContentFragmentFragmentDoc } from '../../../gui/components/yi-content-page-details/YISeriesContentForm/YISeriesContentFragment.generated'
import { YiSeriesEpisode_ContentFragmentFragmentDoc } from '../../../gui/components/yi-content-page-details/YISeriesEpisodeContentForm/YISeriesEpisodeContentFragment.generated'
import { YiCourseModule_ContentFragmentFragmentDoc } from '../../../gui/components/yi-content-page-details/YICourseModuleContentForm/YICourseModuleContentFragment.generated'
import { YiCourseSection_ContentFragmentFragmentDoc } from '../../../gui/components/yi-content-page-details/YICourseSectionContentForm/YICourseSectionContentFragment.generated'
import { YiTeacher_ContentFragmentFragmentDoc } from '../../../gui/components/yi-content-page-details/YITeacherContentForm/YITeacherContentFragment.generated'
import { YiTag_ContentFragmentFragmentDoc } from '../../../gui/components/yi-content-page-details/YITagContentForm/YITagContentFragment.generated'
import { YiTagGroup_ContentFragmentFragmentDoc } from '../../../gui/components/yi-content-page-details/YITagGroupContentForm/YITagGroupContentFragment.generated'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type YiContentQueryQueryVariables = Types.Exact<{
  where: Types.ContentWhereInput
}>

export type YiContentQueryQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      id?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
      publishedAtDate?: any | null
      createdAt?: any | null
      updatedAt?: any | null
      title?: string | null
      path?: string | null
      shortDescription?: string | null
      description?: string | null
      language?: string | null
      contentPolicyPolicyId?: number | null
      descriptionFormat?: string | null
      shortDescriptionFormat?: string | null
      displayType?: string | null
      primaryLanguage?: string | null
      productType?: string | null
      seoDescription?: string | null
      seoTitle?: string | null
      featureMediaId?: string | null
      episodeNumber?: number | null
      seasonNumber?: number | null
      director?: string | null
      producer?: string | null
      writer?: string | null
      studio?: string | null
      copyright?: string | null
      instructor?: string | null
      cast?: string | null
      seoKeywords?: string | null
      seoRobotsNoFollow?: boolean | null
      seoRobotsNoIndex?: boolean | null
      excludeFromRecommendations?: boolean | null
      contentSearchNoIndex?: boolean | null
      titleGroupId?: string | null
      previewMediaId?: string | null
      yiContentType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      yiTags?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      yiYogaStyle?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      yiYogaLevel?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      yiYogaTeacher?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: {
          __typename?: 'ContentReferenceType'
          id?: string | null
          type?: string | null
        } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          title?: string | null
          language?: string | null
          contentType?: string | null
          contentId?: number | null
          published?: boolean | null
          avatar?: Array<{
            __typename?: 'ImageContentRelationship'
            id?: string | null
            type?: string | null
            image?: { __typename?: 'Image'; id?: string | null; url?: string | null } | null
          } | null> | null
        } | null> | null
      } | null> | null
      yiPracticeType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      contentProvider?: {
        __typename?: 'ContentProvider'
        provider?: Types.ContentProviderProviders | null
        providerKey?: string | null
        contentId?: string | null
      } | null
      contentPolicy?: {
        __typename?: 'ContentPolicy'
        policyId?: string | null
        name?: string | null
      } | null
      yiActionType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: {
          __typename?: 'ContentReferenceType'
          id?: string | null
          type?: string | null
        } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          title?: string | null
          language?: string | null
          contentType?: string | null
          contentId?: number | null
          published?: boolean | null
          avatar?: Array<{
            __typename?: 'ImageContentRelationship'
            id?: string | null
            type?: string | null
            image?: { __typename?: 'Image'; id?: string | null; url?: string | null } | null
          } | null> | null
        } | null> | null
      } | null> | null
      yiCourseModules?: Array<{
        __typename?: 'ContentReference'
        sortKey?: number | null
        id?: string | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          title?: string | null
          id?: string | null
          contentType?: string | null
          contentId?: number | null
          published?: boolean | null
          yiCourseModuleType?: Array<{
            __typename?: 'ContentReference'
            id?: string | null
            sortKey?: number | null
            contentReferenceType?: {
              __typename?: 'ContentReferenceType'
              type?: string | null
            } | null
            contentTo?: Array<{
              __typename?: 'Content'
              id?: string | null
              titleGroupId?: string | null
              title?: string | null
              contentId?: number | null
              contentType?: string | null
              published?: boolean | null
              yiTagGroup?: Array<{
                __typename?: 'ContentReference'
                contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
              } | null> | null
            } | null> | null
          } | null> | null
          providerMetadata?: {
            __typename?: 'ContentProvider'
            metadata?: any | null
            contentId?: string | null
          } | null
        } | null> | null
      } | null> | null
      yiCourseSalesPages?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        contentFrom?: Array<{
          __typename?: 'Content'
          id?: string | null
          contentType?: string | null
          contentId?: number | null
          title?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      adminCategory?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      category?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      centers?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      contentOrigin?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      consciousFormat?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      consciousTopic?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      filmSubject?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      filmType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      fitnessDuration?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      fitnessLevel?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      fitnessInstructor?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      fitnessSpecialty?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      fitnessStyle?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      genres?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      interviewGuest?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      interviewHost?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      marketingCenters?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      meditationFocus?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      meditationStyle?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      meditationTeacher?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      meditationDuration?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      onboardingChoices?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      product?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      rainbowCategory?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      recipeDiet?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      recipeType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      series?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      similarVideos?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      thirdPartyGenre?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      videoCollection?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      videoTopic?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      yogaDuration?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      yogaFocus?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      yogaLevel?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      yogaStyle?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      yogaTeacher?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      yiPosePronunciation?: Array<{
        __typename?: 'ContentAssetReference'
        id?: string | null
        contentAssetReferenceTypesId?: string | null
        asset?: {
          __typename?: 'Asset'
          id?: string | null
          renderUrl?: string | null
          originalFileName?: string | null
          uuid?: string | null
        } | null
      } | null> | null
      yiArticleTopic?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      yiCourses?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          contentType?: string | null
          contentId?: number | null
          title?: string | null
          published?: boolean | null
          contentProvider?: {
            __typename?: 'ContentProvider'
            provider?: Types.ContentProviderProviders | null
            providerKey?: string | null
            contentId?: string | null
          } | null
        } | null> | null
      } | null> | null
      yiGiveAwayCourses?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          contentType?: string | null
          contentId?: number | null
          title?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiPromotedContent?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          contentType?: string | null
          contentId?: number | null
          title?: string | null
          published?: boolean | null
          contentProvider?: {
            __typename?: 'ContentProvider'
            provider?: Types.ContentProviderProviders | null
            providerKey?: string | null
            contentId?: string | null
          } | null
          yiContentType?: Array<{
            __typename?: 'ContentReference'
            id?: string | null
            sortKey?: number | null
            contentReferenceType?: {
              __typename?: 'ContentReferenceType'
              type?: string | null
            } | null
            contentTo?: Array<{
              __typename?: 'Content'
              id?: string | null
              titleGroupId?: string | null
              title?: string | null
              contentId?: number | null
              contentType?: string | null
              published?: boolean | null
              yiTagGroup?: Array<{
                __typename?: 'ContentReference'
                contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
              } | null> | null
            } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      yiHomepageHeroContent?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          contentType?: string | null
          contentId?: number | null
          title?: string | null
          published?: boolean | null
          yiContentType?: Array<{
            __typename?: 'ContentReference'
            id?: string | null
            sortKey?: number | null
            contentReferenceType?: {
              __typename?: 'ContentReferenceType'
              type?: string | null
            } | null
            contentTo?: Array<{
              __typename?: 'Content'
              id?: string | null
              titleGroupId?: string | null
              title?: string | null
              contentId?: number | null
              contentType?: string | null
              published?: boolean | null
              yiTagGroup?: Array<{
                __typename?: 'ContentReference'
                contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
              } | null> | null
            } | null> | null
          } | null> | null
          contentProvider?: {
            __typename?: 'ContentProvider'
            provider?: Types.ContentProviderProviders | null
            providerKey?: string | null
            contentId?: string | null
          } | null
        } | null> | null
      } | null> | null
      yiSeriesEpisodes?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          title?: string | null
          id?: string | null
          contentType?: string | null
          contentId?: number | null
          published?: boolean | null
          seasonNumber?: number | null
          episodeNumber?: number | null
          providerMetadata?: {
            __typename?: 'ContentProvider'
            metadata?: any | null
            contentId?: string | null
          } | null
        } | null> | null
      } | null> | null
      yiSeries?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentFrom?: Array<{
          __typename?: 'Content'
          id?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          title?: string | null
          language?: string | null
          primaryLanguage?: string | null
        } | null> | null
      } | null> | null
      yiCourseModuleType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      yiConsumptionType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      yiYogaStyles?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      yiTagGroup?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiTagsRelatedToGroup?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentFrom?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      featureMedia?: {
        __typename?: 'Media'
        mediaId?: string | null
        contentId?: string | null
        mediaMaestroTitleCode?: string | null
        policyId?: number | null
        updatedAt?: any | null
        duration?: number | null
        isPublished?: boolean | null
        mediaAssets?: Array<{
          __typename?: 'MediaAsset'
          id?: string | null
          providerKey?: string | null
        } | null> | null
      } | null
      providerMetadata?: {
        __typename?: 'ContentProvider'
        metadata?: any | null
        contentId?: string | null
      } | null
      previewMedia?: {
        __typename?: 'Media'
        mediaId?: string | null
        contentId?: string | null
        mediaMaestroTitleCode?: string | null
        policyId?: number | null
        updatedAt?: any | null
        duration?: number | null
        isPublished?: boolean | null
        mediaAssets?: Array<{
          __typename?: 'MediaAsset'
          id?: string | null
          providerKey?: string | null
        } | null> | null
      } | null
      yiCourseModuleDownload?: Array<{
        __typename?: 'ContentAssetReference'
        id?: string | null
        asset?: {
          __typename?: 'Asset'
          id?: string | null
          mimeType?: string | null
          fileSize?: number | null
          originalFileName?: string | null
          renderUrl?: string | null
          contentAssetReference?: {
            __typename?: 'ContentAssetReference'
            assetsId?: string | null
          } | null
        } | null
      } | null> | null
    } | null> | null
  } | null
}

export const YiContentQueryDocument = gql`
  query YIContentQuery($where: ContentWhereInput!) {
    contentList(where: $where, limit: 1) {
      content {
        ...Common_ContentFragment
        ...YIClass_ContentFragment
        ...YICourse_ContentFragment
        ...YIMeditation_ContentFragment
        ...GaiaVideo_ContentFragment
        ...YIPose_ContentFragment
        ...YIArticle_ContentFragment
        ...YICourseSales_ContentFragment
        ...YIMemberPromo_ContentFragment
        ...YIHomepageHero_ContentFragment
        ...YISeries_ContentFragment
        ...YISeriesEpisode_ContentFragment
        ...YICourseModule_ContentFragment
        ...YICourseSection_ContentFragment
        ...YITeacher_ContentFragment
        ...YITag_ContentFragment
        ...YITagGroup_ContentFragment
      }
    }
  }
  ${Common_ContentFragmentFragmentDoc}
  ${YiClass_ContentFragmentFragmentDoc}
  ${YiCourse_ContentFragmentFragmentDoc}
  ${YiMeditation_ContentFragmentFragmentDoc}
  ${GaiaVideo_ContentFragmentFragmentDoc}
  ${YiPose_ContentFragmentFragmentDoc}
  ${YiArticle_ContentFragmentFragmentDoc}
  ${YiCourseSales_ContentFragmentFragmentDoc}
  ${YiMemberPromo_ContentFragmentFragmentDoc}
  ${YiHomepageHero_ContentFragmentFragmentDoc}
  ${YiSeries_ContentFragmentFragmentDoc}
  ${YiSeriesEpisode_ContentFragmentFragmentDoc}
  ${YiCourseModule_ContentFragmentFragmentDoc}
  ${YiCourseSection_ContentFragmentFragmentDoc}
  ${YiTeacher_ContentFragmentFragmentDoc}
  ${YiTag_ContentFragmentFragmentDoc}
  ${YiTagGroup_ContentFragmentFragmentDoc}
`

/**
 * __useYiContentQueryQuery__
 *
 * To run a query within a React component, call `useYiContentQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useYiContentQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYiContentQueryQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useYiContentQueryQuery(
  baseOptions: Apollo.QueryHookOptions<YiContentQueryQuery, YiContentQueryQueryVariables> &
    ({ variables: YiContentQueryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<YiContentQueryQuery, YiContentQueryQueryVariables>(
    YiContentQueryDocument,
    options,
  )
}
export function useYiContentQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<YiContentQueryQuery, YiContentQueryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<YiContentQueryQuery, YiContentQueryQueryVariables>(
    YiContentQueryDocument,
    options,
  )
}
// @ts-ignore
export function useYiContentQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<YiContentQueryQuery, YiContentQueryQueryVariables>,
): Apollo.UseSuspenseQueryResult<YiContentQueryQuery, YiContentQueryQueryVariables>
export function useYiContentQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<YiContentQueryQuery, YiContentQueryQueryVariables>,
): Apollo.UseSuspenseQueryResult<YiContentQueryQuery | undefined, YiContentQueryQueryVariables>
export function useYiContentQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<YiContentQueryQuery, YiContentQueryQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<YiContentQueryQuery, YiContentQueryQueryVariables>(
    YiContentQueryDocument,
    options,
  )
}
export type YiContentQueryQueryHookResult = ReturnType<typeof useYiContentQueryQuery>
export type YiContentQueryLazyQueryHookResult = ReturnType<typeof useYiContentQueryLazyQuery>
export type YiContentQuerySuspenseQueryHookResult = ReturnType<
  typeof useYiContentQuerySuspenseQuery
>
export type YiContentQueryQueryResult = Apollo.QueryResult<
  YiContentQueryQuery,
  YiContentQueryQueryVariables
>
